/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-05-31 14:46:59
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\user\activation\locales\zh-CN.ts
 */
export default {
  'page.activation.txtone': '账号激活邮件已发送到您的邮箱',
  'page.activation.txtstart': '请在',
  'page.activation.txttime': '60分钟',
  'page.activation.txtend': '内前往邮箱进行激活',
  'page.activation.btnback': '返回',
  'page.activation.gotoemail': '请前往邮箱进行激活',
  'page.success.txtsucess': '注册成功，请登录后及时认证并完善个人信息。',
  'page.activation.txterror': '注册失败',
  'page.success.login': '登录',
  'page.success.regist': '重新注册',
};
